import React, {PropTypes} from 'react';
import PureComponent from 'components/PureComponent';
import {Link} from 'react-router';

class MenuItem extends PureComponent {
	render() {
		return (
			<li className="Menu__item">
				<Link to={this.props.url} onClick={this.props.onClick} className="Menu__link">
					{this.props.children}
				</Link>
			</li>
		);
	}
}

MenuItem.propTypes = {
	url: PropTypes.string.isRequired
};

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuItem.js